var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkLogoOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 122,
    viewBox: "0 0 90 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.77 44.88V60.88H89.77V44.88H73.77ZM0 76.88H16V60.88H0V76.88Z",
    fill: "#00B8B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.88 0C28.95 0 16 12.96 16 28.88V60.88H32V28.88C32 21.78 37.78 16 44.88 16C51.98 16 57.76 21.78 57.76 28.88V44.88H73.76V28.88C73.77 12.96 60.81 0 44.88 0ZM57.76 92.88C57.76 99.98 51.98 105.76 44.88 105.76C37.78 105.76 32 99.98 32 92.88V76.88H16V92.88C16 108.81 28.96 121.76 44.88 121.76C60.8 121.76 73.76 108.8 73.76 92.88V60.88H57.76V92.88Z",
    fill: "#1F0F48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLogoOnly);
export default __webpack_public_path__ + "static/media/Dark-logo-only.4584a8875aa54797ef4477483c83ebd2.svg";
export { ForwardRef as ReactComponent };